type Position = null | "review" | "question"

let internalPosition: Position = null

export const setPosition = (nextPosition: Position) => {
  internalPosition = nextPosition
}

export const getPosition = () => internalPosition
